import styled, { css } from "styled-components";

export const ItemWrapper = styled.div`
  margin: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  > p {
    margin: 0px;
    font-size: var(--textS);
    line-height: var(--lineHeightS);
  }

  ${({ $isFirst }) => $isFirst && "font-weight: bold;"}
`;

export const IconWrapper = styled.div`
  ${({ hideIcon }) =>
    hideIcon &&
    css`
      display: none;
    `}
`;

export default ItemWrapper;
